import { useParams } from 'react-router-dom'
import { ContactsContainer } from '../../../containers/ContactsContainer'
import { QUERY_PARAMS } from '../../../constants'
import ConflictCheck from '../../../components/conflictCheck'

export const Contacts = () => {
  const { type } = useParams()
  return type === QUERY_PARAMS.CONFLICT_CHECKS ? <ConflictCheck /> : <ContactsContainer isClient={type === 'client'} />
}
